import styled from "styled-components";

// Main Container - ScrollFrame
export const RatingLoadingContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const RatingContainer = styled.div`
  position: absolute;
  width: 440px;
  height: 831px;
  left: 0px;
  top: 125px;
`;

// AppFrames_com
export const AppFramesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 43px 20px 0px;
  gap: 23px;
  position: absolute;
  height: 750px;
  left: 0px;
  right: 0px;
  top: 0px;
`;

// Header Section
export const HeaderSection = styled.div`
  background: ${({ theme }) => theme.colors.white};
  padding: 16px;

  @media (min-width: 768px) {
    margin-bottom: 16px;
  }
`;

// RatingMain
export const RatingOverviewSection = styled.div`
  @media (min-width: 768px) {
    margin-bottom: 16px;
    border-bottom: none;
  }
`;

export const RatingOverviewContent = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
    gap: 60px;
  }

  @media (min-width: 1024px) {
    gap: 80px;
  }
`;

// Rating m (Left section)
export const RatingScoreSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 10px;
  width: 100px;
  height: 117px;
  flex: none;
  order: 0;
  flex-grow: 0;

  @media (min-width: 768px) {
    width: 25%;
    height: 117px;
  }
`;

// 4.2 (Rating score)
export const RatingScore = styled.div`
  width: 58px;
  height: 47px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 40px;
  line-height: 47px;
  color: ${({ theme }) => theme.colors.text};
  flex: none;
  order: 0;
  flex-grow: 0;
`;

// Stars_L
export const StarContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  width: 148.33px;
  height: 31px;
  flex: none;
  order: 1;
  flex-grow: 0;
`;

// Star1
export const StarIcon = styled.div`
  width: 24.07px;
  height: 23px;
  flex: none;
  flex-grow: 0;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    left: 2.7%;
    right: 81.08%;
    top: 12.9%;
    bottom: 12.9%;
    background: ${({ color, theme }) => (color as any) || theme.colors.primary};
  }
`;

// 625 Ratings
export const TotalReviews = styled.div`
  width: 87px;
  height: 19px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: ${({ theme }) => theme.colors.text};
  flex: none;
  order: 2;
  flex-grow: 0;
`;

// Rating Breakdown
export const RatingBreakdownSection = styled.div`
  flex: 1;
`;

export const RatingBreakdownItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const RatingNumber = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.darkGray};
  min-width: 8px;
`;

export const RatingBar = styled.div`
  flex: 1;
  height: 8px;
  overflow: hidden;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.underline};
`;

export const RatingBarFill = styled.div<{ $percentage: number }>`
  height: 100%;
  background-color: ${({ theme }) => theme.colors.primary};
  width: ${(props) => props.$percentage}%;
  transition: width 0.3s ease;
`;

export const RatingPercentage = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.darkGray};
  min-width: 40px;
  text-align: right;
`;

// ReviewFilter
export const ReviewsSection = styled.div``;

// All Reviews
export const ReviewsHeader = styled.div`
  width: 400px;
  height: 28px;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
`;

export const ReviewsTitle = styled.h2`
  width: 400px;
  height: 28px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
  color: ${({ theme }) => theme.colors.text};
  margin: 0;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
`;

// Line separator
export const ReviewsHeaderLine = styled.div`
  width: 100%;
  height: 0px;
  border: 2px solid ${({ theme }) => theme.colors.border};
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
`;

// RatingScroll1
export const FilterScrollContainer = styled.div``;

// ReviewTag
type SidebarProps = {
  $isSidebarCollapsed?: boolean;
};

export const FilterTabs = styled.div<SidebarProps>`
  gap: 8px;
  display: grid;

  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;

  @media (max-width: 811px) {
    grid-template-columns: 1fr 1fr 1fr;
  }

  @media (min-width: 812px and max-width: 1279px) {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  }

  @media (min-width: 1280px) {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  }
`;

// Tags (Filter buttons)
export const FilterTab = styled.button<{ $active: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 5px 15px;
  gap: 10px;
  height: 29px;
  background: ${({ $active, theme }) => ($active ? theme.colors.primary : theme.colors.lightGray)};
  border-radius: 25px;
  border: none;
  cursor: pointer;
  flex: none;
  flex-grow: 0;

  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: ${({ $active, theme }) => ($active ? theme.colors.TextWhite : theme.colors.text)};

  &:hover {
    opacity: 0.8;
  }
`;

// ReviewScroll
export const ReviewScrollContainer = styled.div`
  width: 400px;
  height: 467px;
  overflow-y: scroll;
  flex: none;
  order: 2;
  flex-grow: 0;
`;

export const ReviewsList = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 16px;

  @media (max-width: 1009px) {
    grid-template-columns: 1fr;
  }

  @media screen and (min-width: 1010px) and (max-width: 1279px) {
    grid-template-columns: 1fr 1fr;
  }
`;

// Review Frame
export const ReviewItem = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px;
  background: ${({ theme }) => theme.colors.hoverColor};
  border-radius: 15px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow: visible;
`;

// Frame 8044
export const ReviewItemContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 23px;
  gap: 8px;
  width: 100%;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
`;

// Frame 8049
export const ReviewContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  width: 100%;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
`;

// Frame 8139
export const ReviewMainContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0px;
  gap: 12px;
  width: 100%;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
`;

// ProfileFrame
export const ReviewHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  width: 100%;
  max-width: 100%;
  height: 40px;
  box-sizing: border-box;
  overflow: visible;
`;

// Profile
export const ReviewerAvatar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 7px;
  gap: 10px;
  width: 40px;
  height: 40px;
  background: ${({ theme }) => theme.colors.hoverColor};
  border-radius: 30px;
  flex: none;
  order: 0;
  flex-grow: 0;

  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  color: ${({ theme }) => theme.colors.primary};
`;

export const ReviewerInfo = styled.div`
  flex: 1;
`;

// Siew H.
export const ReviewerName = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  color: ${({ theme }) => theme.colors.text};

  max-height: 19px;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  @media (max-width: 1009px) {
    max-width: 300px;
  }

  @media (max-width: 767px) {
    max-width: 200px;
  }

  @media (max-width: 459px) {
    max-width: 132px;
  }

  @media (min-width: 1280px) {
    max-width: 190px;
  }

  @media screen and (min-width: 1010px) and (max-width: 1279px) {
    max-width: 200px;
  }
`;

export const ReviewActions = styled.div`
  position: relative;
`;

export const ReviewMenuButton = styled.button`
  width: 32px;
  border: none;
  background: none;
  cursor: pointer;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.darkGray};
`;

export const ReviewMenuDropdown = styled.div<{ $isOpen: boolean }>`
  position: absolute;
  top: 100%;
  right: 0;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.underline};
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 2100;
  min-width: 120px;
  margin-top: 4px;
  display: ${(props) => (props.$isOpen ? "block" : "none")};
`;

export const ReviewMenuOption = styled.button`
  width: 100%;
  padding: 8px 12px;
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text};

  &:first-child {
    border-radius: 8px 8px 0 0;
  }

  &:last-child {
    border-radius: 0 0 8px 8px;
  }
`;

// Star Detail
export const ReviewStarDetail = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 12px;
  width: 164px;
  height: 14px;
  flex: none;
  order: 1;
  flex-grow: 0;
`;

// Stars_S
export const ReviewStars = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 3px;
  width: 72px;
  height: 11.47px;
  flex: none;
  order: 0;
  flex-grow: 0;
`;

// Small star
export const ReviewStarIcon = styled.div`
  width: 12px;
  height: 11.47px;
  flex: none;
  flex-grow: 0;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    left: 0%;
    right: 83.33%;
    top: 0%;
    bottom: 0%;
    background: ${({ color, theme }) => (color as any) || theme.colors.primary};
  }
`;

// Frame 8142 (Time info)
export const ReviewTimeFrame = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 5px;
  width: 80px;
  height: 14px;
  flex: none;
  order: 1;
  flex-grow: 0;
`;

// Ellipse 127
export const ReviewTimeDot = styled.div`
  width: 4px;
  height: 4px;
  background: ${({ theme }) => theme.colors.disabled};
  flex: none;
  order: 0;
  flex-grow: 0;
`;

// 15 hours ago
export const ReviewDate = styled.div`
  height: 14px;
  white-space: nowrap;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: ${({ theme }) => theme.colors.disabled};
  flex: none;
  order: 1;
  flex-grow: 0;
`;

// Review content text
export const ReviewContent = styled.p`
  width: 100%;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.text};
`;

// Loading and Empty States
export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
`;

export const LoadingSpinner = styled.div`
  width: 32px;
  height: 32px;
  border: 3px solid ${({ theme }) => theme.colors.underline};
  border-top: 3px solid ${({ theme }) => theme.colors.primary};
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: ${({ theme }) => theme.colors.darkGray};
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px 20px;
  color: ${({ theme }) => theme.colors.darkGray};
`;

export const EmptyStateIcon = styled.div`
  width: 64px;
  height: 64px;
  margin-bottom: 16px;
  color: ${({ theme }) => theme.colors.disabled};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
`;

export const EmptyStateTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text};
  margin: 0 0 8px 0;
`;

export const EmptyStateDescription = styled.p`
  font-size: 14px;
  margin: 0;
  line-height: 1.5;
  max-width: 400px;
`;

// Local styled-components for the Report modal UI
export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  width: 100%;
  max-width: 420px;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 12px;
  padding: 20px 24px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
`;

export const ModalTitle = styled.h3`
  margin: 0 0 8px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text};
`;

export const ModalSubtitle = styled.p`
  margin: 0 0 16px;
  text-align: center;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.placeholder};
`;

export const ReasonsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
`;

export const ReasonRow = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  background: transparent;
  border: none;
  text-align: left;
  padding: 6px 0;
  cursor: pointer;
`;

export const Checkbox = styled.span<{ $checked: boolean }>`
  width: 20px;
  height: 20px;
  border: 1px solid ${({ theme }) => theme.colors.primary};
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 3px;
  font-size: 14px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.primary};
  
  &::after {
    content: ${(p) => (p.$checked ? '"✓"' : '""')};
  }
`;

export const CheckMark = styled.span`
  width: 10px;
  height: 10px;
  display: block;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 2px;
`;

export const ReasonText = styled.span`
  color: ${({ theme }) => theme.colors.text};
  font-size: 14px;
`;

export const MarkedLabel = styled.span`
  margin-left: auto;
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.primary};
`;

export const ButtonsRow = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  width:100%;
`;

export const BackButton = styled.button`
  padding: 8px 14px;
  border-radius: 20px;
  border: none;
  background: ${({ theme }) => theme.colors.secondary};
  color: ${({ theme }) => theme.colors.white};
  font-weight: 600;
  cursor: pointer;
`;

export const ReportButton = styled.button`
  padding: 8px 14px;
  border-radius: 20px;
  border: none;
  background: ${({ theme }) => theme.colors.primaryDark};
  color: ${({ theme }) => theme.colors.white};
  font-weight: 600;
  cursor: pointer;
`;
